import { Platform } from 'react-native';

import getRouteRootPath from './getRouteRootPath.web';

/**
 * Designed to support rev links for absolute urls for Web Messaging and Live Chat
 *
 * Return the scheme, host and root path (if any) without a trailing slash
 * e.g.
 * on iOS & Android: https://messaging.subsplash.com/
 * on Web w/ a revision url: https://messaging.subsplash.com/rev:some-slug/
 * on localhost: http://localhost:8082/ (uses actual localhost origin)
 */
export default (host: string): string => {
  if (Platform.OS !== 'web') {
    return host;
  }

  // Use localhost origin when running on localhost
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname === 'localhost'
  ) {
    const str = `${window.location.origin}${getRouteRootPath()}`;

    // remove trailing slash
    return str.endsWith('/') ? str.slice(0, -1) : str;
  }

  const str = `${host}${getRouteRootPath()}`;

  // remove trailing slash
  return str.endsWith('/') ? str.slice(0, -1) : str;
};
